import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      localStorage.setItem('adminToken', response.data.access_token);
      toast({
        title: "Login successful!",
        description: "Welcome to the admin panel.",
      });
      navigate('/admin');
    } catch (error) {
      toast({
        title: "Login failed",
        description: "Incorrect password. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink via-burgundy/20 to-burgundy flex items-center justify-center px-6">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-burgundy rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <Card className="w-full max-w-md border-2 border-burgundy/30 shadow-2xl relative z-10 bg-white">
        <CardHeader className="text-center bg-gradient-to-br from-pink/30 to-burgundy/10">
          <div className="flex justify-center mb-4">
            <div className="p-4 bg-burgundy rounded-full">
              <Lock className="w-8 h-8 text-white" />
            </div>
          </div>
          <CardTitle className="text-3xl font-playfair font-bold text-burgundy flex items-center justify-center gap-2">
            <Sparkles className="w-6 h-6" />
            Admin Login
          </CardTitle>
          <CardDescription className="text-base">
            Enter your password to access the admin panel
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="password" className="text-gray-700 font-semibold">
                Password
              </Label>
              <Input
                id="password"
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter admin password"
                className="border-2 border-gray-300 focus:border-burgundy focus:ring-burgundy"
                disabled={isLoading}
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-burgundy to-bordeaux hover:from-bordeaux hover:to-burgundy text-white rounded-full font-semibold py-6 text-base"
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>

            <div className="text-center">
              <Button
                type="button"
                variant="link"
                onClick={() => navigate('/')}
                className="text-burgundy hover:text-bordeaux"
              >
                Back to Website
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
